module.exports = __webpack_public_path__ + "img/iconBusinessShuiFenJianCeHanLiang.e06d8e0a.svg";